export default function GradientOrb() {
    return (
        <div
            aria-hidden
            className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
            data-testid="gradient-orb"
        >
            {/* Primary orb (electric blue) */}
            <div
                className="absolute -top-40 left-1/2 h-[680px] w-[680px] -translate-x-1/2 rounded-full opacity-60"
                style={{
                    background:
                        "radial-gradient(circle at 50% 50%, rgba(47,88,205,0.35) 0%, rgba(47,88,205,0.08) 40%, rgba(11,15,25,0) 70%)",
                    filter: "blur(20px)",
                    animation: "orb-drift 12s ease-in-out infinite",
                }}
            />
            {/* Secondary orb (mint) */}
            <div
                className="absolute top-[40vh] left-[60%] h-[420px] w-[420px] rounded-full opacity-30"
                style={{
                    background:
                        "radial-gradient(circle at 50% 50%, rgba(0,245,212,0.22) 0%, rgba(0,245,212,0.04) 45%, rgba(11,15,25,0) 75%)",
                    filter: "blur(28px)",
                    animation: "orb-drift 16s ease-in-out infinite reverse",
                }}
            />
            {/* Grain texture for depth */}
            <div
                className="absolute inset-0 opacity-[0.025]"
                style={{
                    backgroundImage:
                        "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 240 240' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
                }}
            />
        </div>
    );
}
